import React, { Component, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const IconMenu = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    return (

        <div>
            <IconButton id={props.id} onClick={handleClick}>
                {props.icon ? props.icon : <MoreHorizIcon />}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >

                {props.options.map((item, index) => (
                    <MenuItem
                        key={index}
                        disabled={item.disabled}
                        onClick={() => {
                            item.onClick();

                        }}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>



    );

}

export default IconMenu;
